import * as actionTypes from '../actionTypes'
import api from '../api'

export const open = () => {
	return async (dispatch, getState) => {
		dispatch(openAction())
	}
}

const openAction = () => ({
	type: actionTypes.OPEN_DIALOG
})

export const close = () => {
	return async (dispatch, getState) => {
		dispatch(closeAction())
	}
}

const closeAction = () => ({
	type: actionTypes.CLOSE_DIALOG
})

export const cancel = () => {
	return async (dispatch, getState) => {
		dispatch(cancelAction())
	}
}

const cancelAction = () => ({
	type: actionTypes.CLEAR
})

export const closeNestedDialog = () => {
	return async (dispatch, getState) => {
		dispatch(closeNestedDialogAction())
	}
}

const closeNestedDialogAction = () => ({
	type: actionTypes.CLOSE_NESTED_DIALOG
})

export const handleFormChangeValue = (event) => {
	return async (dispatch, getState) => {
		dispatch(dialogChangeEvent(event.target.name, event.target.value))
	}
}

const dialogChangeEvent = (field, value) => ({
	type: actionTypes.DIALOG_CHANGE,
	value: value,
	field: field
})

export const handleFormChangeValueSelect = (event) => {
	return async (dispatch, getState) => {
		dispatch(dialogChangeSelectEvent(event.target.name, event.target.value))
	}
}

const dialogChangeSelectEvent = (field, value) => ({
	type: actionTypes.DIALOG_CHANGE_SELECT,
	value: value,
	field: field
})

export const loadPref = (id, isLbb) => {
	return async (dispatch, getState) => {
		if (!isLbb) {
			const response = await api.service('fleetLocations').find({
				query: {
					id: { $eq: id },
					$include: [
						'fleet',
						'parent.locationType',
						'locationType',
						'address.country',
						'authorizationPreference',
						'contacts.contactNumbers',
						'contacts.contactTypes',
						'axleCheckPreference.axleCheckDetails',
						'axleTirePreference.axleTireDetails.size',
						'axleWheelPreference.axleWheelDetails',
						'missingTirePreference',
						'valveStemRulesPreference',
						'poPreference',
						'billingPreference',
						'otherAccounts.otherAccountType',
					],
				}
			})

			let fleetLocations = response.data[0]
			let billToContacts = []
			let billToInfo
			if (fleetLocations.locationType.name === 'Shipping' && fleetLocations.parent !== null) {
				billToContacts = await api.service('fleetLocationsContacts').find({
					query: {
						locationId: { $eq: fleetLocations.parent.id },
						$include: [
							'contact.contactTypes',
							'contact.contactNumbers',
						]
					}
				})
				billToInfo = await api.service('fleetLocations').find({
					query: {
						id: { $eq: fleetLocations.parent.id },
						$include: [
							'authorizationPreference',
							'axleCheckPreference.axleCheckDetails',
							'axleTirePreference.axleTireDetails.size',
							'axleWheelPreference.axleWheelDetails',
							'poPreference',
							'billingPreference',
							'otherAccounts.otherAccountType',
						]
					}
				})
			}

			if (!billToInfo) {
				billToInfo = false
			} else {
				billToInfo = billToInfo.data[0]
			}
			dispatch(loadPrefAction(fleetLocations, billToContacts.data, billToInfo))

			let resp = await api.service('fleets').find({
				query: {
					id: { $eq: response.data[0].accountId },
					$include: ['fleetLocations']
				}
			})

			let billToDRopDown = resp.data[0].fleetLocations.reduce((billToCollector, l) => {
				if (l.isBillTo) {
					billToCollector.push({ id: l.id, name: l.id })
				}
				return billToCollector
			}, [])

			dispatch(loadBillTosAction(billToDRopDown))

			let shipToDRopDown = resp.data[0].fleetLocations.reduce((shipToCollector, l) => {
				if (l.isShipTo) {
					shipToCollector.push({ id: l.id, name: l.id })
				}
				return shipToCollector
			}, [])

			dispatch(loadShipTosAction(shipToDRopDown))
		} else {
			const lbbResponse = await api.service('localAccounts').find({
				query: {
					id: { $eq: id },
					$include: [
						'address.country',
						'authorizationPreference',
						'contacts.contactTypes',
						'contacts.contactNumbers',
						'dealerLocation',
						'axleCheckPreference.axleCheckDetails',
						'axleTirePreference.axleTireDetails.size',
						'axleWheelPreference.axleWheelDetails',
						'missingTirePreference',
						'valveStemRulesPreference',
						'poPreference',
						'billingPreference',
					]
				}
			})

			dispatch(loadLbbResults(lbbResponse.data[0]))
		}
	}
}

const loadShipTosAction = (data) => ({
	type: actionTypes.LOAD_SHIP_TOS,
	data: data
})

const loadBillTosAction = (data) => ({
	type: actionTypes.LOAD_BILL_TOS,
	data: data
})

const loadPrefAction = (data, billToContacts, billToInfo) => ({
	type: actionTypes.LOAD_PREF,
	pref: data,
	billToContacts: billToContacts,
	billToInfo: billToInfo
})

const loadLbbResults = (data) => ({
	type: actionTypes.LOAD_PREF,
	pref: data,
	lbb: true
})

export const search = (searchObject) => {
	return async (dispatch, getState) => {
		const state = getState()
		const roles = state.login.roles
		searchLBB(searchObject, dispatch, roles)
	}
}

async function searchLBB(searchObject, dispatch, roles) {
	let shipTos = []
	let moreResults = false

	const locationArray = [
		'dealerLocation',
		'dealerLocation.dealer',
		'fleet',
		'fleet.primaryLocation',
		'address',
		'address.country',
	]

	if (searchObject.accountNumber || searchObject.customerName) {
		let and = {}

		if (searchObject.accountNumber) and.account_number = { $iLike: searchObject.accountNumber + '%' }
		if (searchObject.customerName) and.name = { $iLike: '%' + searchObject.customerName + '%' }

		let response = await api.service('localAccounts').find({
			query: {
				$and: and,
				$include: locationArray,
				$limit: 200,
			}
		})

		if (response.total > response.limit) {
			moreResults = true
		}

		shipTos = global.utilities.intersectEmpty(shipTos, response.data)
	}

	if (searchObject.dealerName) {
		let dealerLocationResponse = await api.service('dealerLocations').find({
			query: {
				name: { $iLike: '%' + searchObject.dealerName + '%' },
				$limit: 200,
			}
		})

		if (dealerLocationResponse !== undefined && dealerLocationResponse.data.length > 0) {
			let locations = dealerLocationResponse.data.reduce((id, loc) => {
				id.push(loc.id)
				return id
			}, [])

			if (locations && locations.length > 0) {
				let response = await api.service('localAccounts').find({
					query: {
						dealerLocationId: { $in: locations },
						$include: locationArray,
						$limit: 200,
					}
				})

				if (response.total > response.limit) {
					moreResults = true
				}

				shipTos = global.utilities.intersectEmpty(shipTos, response.data)
			}
		}
	}

	if (searchObject.dealerAddressLine1 || searchObject.dealerCity || searchObject.dealerState || searchObject.dealerZip) {
		let and = {}

		if (searchObject.dealerAddressLine1) and.address = { $iLike: '%' + searchObject.dealerAddressLine1 + '%' }
		if (searchObject.dealerCity) and.city = { $iLike: '%' + searchObject.dealerCity + '%' }
		if (searchObject.dealerState) and.state = { $iLike: searchObject.dealerState }
		if (searchObject.dealerZip) and.zip = { $iLike: '%' + searchObject.dealerZip + '%' }

		let addressResponse = await api.service('addresses').find({
			query: {
				$and: and,
				$include: ['dealerLocations'],
				$limit: 2000,
			}
		})

		if (addressResponse !== undefined && addressResponse.data.length > 0) {
			let locations = addressResponse.data.reduce((ids, address) => {
				var subIds = address.dealerLocations.reduce((id, loc) => {
					id.push(loc.id)
					return id
				}, [])
				ids = ids.concat(subIds)

				return ids
			}, [])

			if (locations && locations.length > 0) {
				let response = await api.service('localAccounts').find({
					query: {
						dealerLocationId: { $in: locations },
						$include: locationArray,
						$limit: 200,
					}
				})

				if (response.total > response.limit) {
					moreResults = true
				}

				shipTos = global.utilities.intersectEmpty(shipTos, response.data)
			}
		}
	}

	if (searchObject.addressLine1 || searchObject.city || searchObject.state || searchObject.zip) {
		let and = {}

		if (searchObject.addressLine1) and.address = { $iLike: '%' + searchObject.addressLine1 + '%' }
		if (searchObject.city) and.city = { $iLike: '%' + searchObject.city + '%' }
		if (searchObject.state) and.state = { $iLike: searchObject.state }
		if (searchObject.zip) and.zip = { $iLike: '%' + searchObject.zip + '%' }

		let addressResponse = await api.service('addresses').find({
			query: {
				$and: and,
				$include: ['localAccounts'],
				$limit: 2000,
			}
		})

		if (addressResponse.total > addressResponse.limit) {
			moreResults = true
		}

		if (addressResponse && addressResponse.data.length > 0) {
			let accountIds = addressResponse.data.reduce((ids, address) => {
				var subIds = address.localAccounts.reduce((id, loc) => {
					id.push(loc.id)
					return id
				}, [])
				ids = ids.concat(subIds)

				return ids
			}, [])
			
			if (accountIds && accountIds.length > 0) {
				let response = await api.service('localAccounts').find({
					query: {
						id: { $in: accountIds },
						$include: locationArray,
						$limit: 200,
					}
				})

				if (response.total > response.limit) {
					moreResults = true
				}

				shipTos = global.utilities.intersectEmpty(shipTos, response.data)
			} else {
				shipTos = []
			}
		}
	}

	let ids = []
	let result = shipTos.filter(loc => {
		if (ids.includes(loc.id)) {
			return false
		}

		if (loc.isBillTo === false && loc.isShipTo === false) {
			return false
		}

		ids.push(loc.id)
		return true
	})

	if (searchObject.country) {
		result = result.filter(loc => loc.address.country.id === searchObject.country)
	}

	dispatch(searchEvent(result, true, moreResults))
}

async function searchNAFA(searchObject, dispatch, roles) {
	let shipTos = []
	let moreResults = false

	const locationArray = [
		'fleet',
		'fleet.primaryLocation',
		'address.country',
	]

	if (searchObject.accountNumber || searchObject.customerName) {
		let and = {}

		if (searchObject.accountNumber) and.account_number = { $iLike: searchObject.accountNumber + '%' }
		if (searchObject.customerName) and.name = { $iLike: '%' + searchObject.customerName + '%' }

		let response = await api.service('fleetLocations').find({
			query: {
				$and: and,
				$include: locationArray,
				$limit: 200,
			}
		})

		if (response.total > response.limit) {
			moreResults = true
		}

		shipTos = global.utilities.intersectEmpty(shipTos, response.data)
	}

	if (searchObject.addressLine1 || searchObject.city || searchObject.state || searchObject.zip) {
		let and = {}

		if (searchObject.addressLine1) and.address = { $iLike: '%' + searchObject.addressLine1 + '%' }
		if (searchObject.city) and.city = { $iLike: '%' + searchObject.city + '%' }
		if (searchObject.state) and.state = { $iLike: searchObject.state }
		if (searchObject.zip) and.zip = { $iLike: '%' + searchObject.zip + '%' }

		let addressResponse = await api.service('addresses').find({
			query: {
				$and: and,
				$include: ['fleetLocations'],
				$limit: 2000,
			}
		})

		if (addressResponse.total > addressResponse.limit) {
			moreResults = true
		}

		if (addressResponse !== undefined && addressResponse.total > 0) {
			let locations = addressResponse.data.reduce((ids, address) => {
				var subIds = address.fleetLocations.reduce((id, loc) => {
					id.push(loc.id)
					return id
				}, [])
				ids = ids.concat(subIds)

				return ids
			}, [])

			if (locations && locations.length > 0) {
				let response = await api.service('fleetLocations').find({
					query: {
						id: { $in: locations },
						$include: locationArray,
						$limit: 200,
					}
				})

				if (response.total > response.limit) {
					moreResults = true
				}

				shipTos = global.utilities.intersectEmpty(shipTos, response.data)
			} else {
				shipTos = []
			}
		} else {
			shipTos = []
		}
	}

	let ids = []
	let result = shipTos.filter(loc => {
		// remove duplicate ids
		if (ids.includes(loc.id)) {
			return false
		}

		// remove home office records, billto=shipto=false
		if (loc.isBillTo === false && loc.isShipTo === false) {
			return false
		}

		ids.push(loc.id)
		return true
	})

	if (searchObject.country) {
		result = result.filter(loc => loc.address.country.id === searchObject.country)
	}

	dispatch(searchEvent(result, false, moreResults))
}

const searchEvent = (shipTos, isLbb, moreResults) => ({
	type: actionTypes.DIALOG_SEARCH,
	data: shipTos,
	isLbb: isLbb,
	moreResults: moreResults
})



// WEBPACK FOOTER //
// ./src/actions/formDialogActions.js